import type { Network } from '../types/shared';

type FullReadableNetworks = 'Facebook' | 'Snapchat' | 'Google' | 'TikTok' | 'X';
type ShortReadableNetworks = 'FB' | 'SN' | 'GGL' | 'TIK' | 'X';

const networks: Record<Network, { full: FullReadableNetworks; short: ShortReadableNetworks }> = {
  facebook: { short: 'FB', full: 'Facebook' },
  snapchat: { short: 'SN', full: 'Snapchat' },
  google: { short: 'GGL', full: 'Google' },
  tiktok: { short: 'TIK', full: 'TikTok' },
  x: { short: 'X', full: 'X' },
} as const;

export const getReadableNetworkName = (n: Network) => networks[n];
